export class Package {
  created: string;
  createdBy: number;
  fundusAutonomousUnit: number = 0;
  fundusUnit: number = 0;
  id: number;
  isSpecific: boolean = false;
  isOffline: boolean = false;
  lastUpdated: string;
  pkgName: string = null;
  price: number = 0;
  referralUnit: number = 0;
  refractionUnit: number = 0;
  spectacleAdvancedUnit: number = 0;
  spectacleBasicUnit: number = 0;
  status: boolean;
  teleRefractionUnit: number = 0;
  validity: number = null;
  accountIds: any[] = [];
  isAiPackageEnabled: boolean = false;
  providerIds: [] = [];
  aiUnit: number = 0;
  category: string = "";
  currency: string = "";
}